import { head } from 'lodash';

class ActivityAddController {
    constructor(basket, addGuestService, guestModalService, validateService, messageService) {
        this.basket = basket;
        this.addGuestService = addGuestService;
        this.guestModalService = guestModalService;
        this.validateService = validateService;
        this.messageService = messageService;
    }

    addToBasket () {
        if (!this.basket.saving && this.time.quantity > 0) {
            let item = this.event;
            item.type = 'Activity';
            item.preferred_time = this.time.time;
            item.end_date_time = this.time.end;
            item.gender = this.time.gender;

            const guests = this.addGuestService.getGuests();

            if (!this.validate(item, guests)) {
                return;
            }

            return this.basket.addToBasket(guests, item)
                .then(() => {
                    this.guestModalService.hide();
                    this.addGuestService.setState({
                        existingGuests: this.basket.contents.guest_details,
                        guests: []
                    });
                    return this.getAvailability(false);
                });
        }
    }

    validate (item, guests) {
        const error = this.validateService.invalidItemOrGuests(item, guests);

        if (error) {
            this.messageService.add(error);
            this.messageService.failure();
            return false;
        }

        return true;
    }

    isDisabled () {
        return this.basket.saving || !this.time.quantity || this.time.quantity < 1;
    }
}

ActivityAddController.$inject = ['basket', 'addGuestService', 'guestModalService', 'validateService', 'messageService'];

export default ActivityAddController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/activity.add.controller.js